import React from 'react'

import { H2 } from '@frame/ui-primitives/h2'
import { P } from '@frame/ui-primitives/p'

type Props = {
  verifierName?: string
}

export function SuccessfullyUploadedOtherDocumentsContent({ verifierName }: Props) {
  const displayName = verifierName || 'the property management team'

  return (
    <>
      <H2 className="mb-3 mt-5 text-center text-moss-700">You're all set</H2>
      <P>Thanks for providing your information. We've handed off your documents to be reviewed by {displayName}.</P>
    </>
  )
}
